import { useEffect, useState } from "react";
import { GuidePostService } from "@oldDashboard/legacyServices/guide-posts/guidePostService";
import { setEngagementDataAction } from "@oldDashboard/legacyActions/dashboardClient";

interface useEngagementProps  {affiliateSelected: any, launchSelected: String, timePeriodSelected: String, startDate: String, endDate: String, searching: boolean }

const useEngagement = (props: useEngagementProps) => {
    const { affiliateSelected, launchSelected, timePeriodSelected, searching, startDate, endDate } = props;
    const [isLoading, setIsLoading] = useState(false);

    useEffect( () => {
        fetchEngagement();
    }, [searching, launchSelected]);

    const fetchEngagement = async() => {
        setIsLoading(true);
        try {
            const service = new GuidePostService();
            const response = await service.getEngagementData(affiliateSelected, launchSelected, timePeriodSelected, startDate, endDate);
            if(response.success) {
                if(Object.keys(response.chart_data).length > 0) {
                    const { engagements, clicks_outbound = "0" } = response.chart_data.data;
                    setEngagementDataAction({engagements, clicksOutbound: clicks_outbound});
                }
            }

        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
            setIsLoading(false);
        }
    }

    return { isLoading, fetchEngagement }
}

export default useEngagement;